<div class="ui-g-12 text-center tournament-name">{{ ds.currentTournament.name }}</div>
<div class="ui-g-12 text-center tournament-info">{{ ds.currentTournament.location }}</div>
<div class="ui-g-12 text-center tournament-info">
    {{ ds.currentTournament.startDate | date : "shortDate" }}
    <span *ngIf="!ds.currentTournament.isTournament">&nbsp;-&nbsp;{{ ds.currentTournament.endDate | date : "shortDate" }}</span>
</div>

<div *ngFor="let summary of summaries; let i = index;" class="ui-g-12 ui-lg-6">
    <div>
        <div class="ui-g-12 info-summary-title">{{ summary.name }}</div>
        <div class="ui-g-12 info-summary-place">
            <span translate>PLACEMENTS.FIRSTPLACE</span>:&nbsp;{{ summary.firstPlace }}
        </div>
        <div class="ui-g-12 info-summary-place">
            <span translate>PLACEMENTS.SECONDPLACE</span>:&nbsp;{{ summary.secondPlace }}
        </div>
        <div class="ui-g-12 info-summary-place">
            <span translate>PLACEMENTS.THIRDPLACE</span>:&nbsp;{{ summary.thirdPlace }}
        </div>
    </div>
</div>